import { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Toolbar,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { formatMoney } from "./Utils";
import DownloadBreakoutButton from "./DownloadBreakoutButton";
import Calculator from "./Calculator";

export default function ReplacementCost(props) {
  const t = props.estatedProperty;
  const data = {
    Luxury: formatMoney(Math.round(t.replacement_costs.luxury)),
    "Semi Luxury": formatMoney(Math.round(t.replacement_costs.semi_luxury)),
    "Best Standard": formatMoney(Math.round(t.replacement_costs.best_std)),
    "Good Standard": formatMoney(Math.round(t.replacement_costs.good_std)),
    "Avg Standard": formatMoney(Math.round(t.replacement_costs.avg_std)),
    "Min Standard": formatMoney(Math.round(t.replacement_costs.min_std)),
  };
  const isEstimate = !Boolean(t.address.apn);
  const label = `Replacement Cost${isEstimate ? "*" : ""}`;
  const disclaimer = isEstimate ? (
    <div>
      *Warning: There is no Estated record for this property. These values are
      based on zip code averages.
    </div>
  ) : (
    ""
  );
  const downloadBreakoutButton = t.replacement_costs.luxury ? (
    <DownloadBreakoutButton style={{ float: "right" }} {...props} />
  ) : null;
  const [state, setState] = useState(false);
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState(open);
  };
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        {label}
        <Button
          style={{ float: "right" }}
          variant="contained"
          size="small"
          onClick={toggleDrawer(true)}
        >
          Edit Replacement Cost
        </Button>
      </Typography>
      <Table size="small">
        <TableBody>
          {Object.keys(data).map((header, index) => (
            <TableRow key={index}>
              <TableCell>{header}</TableCell>
              <TableCell align="right">{data[header]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Typography variant="subtitle2" pt={1}>
        {disclaimer}
      </Typography>
      <div>{downloadBreakoutButton}</div>
      <Drawer anchor="right" open={state} onClose={toggleDrawer(false)}>
        <Toolbar></Toolbar>
        <Box sx={{ width: 600, p: 4 }}>
          <Typography variant="h6" color="primary" gutterBottom>
            Edit Replacement Cost
          </Typography>
          <Calculator {...props} />
        </Box>
      </Drawer>
    </Paper>
  );
}
